import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  TopBarContainer,
  FilterNavWrapper,
  customStylesCompanies,
  FilterTitle
} from "./TopBar.styled";
import Actions from "../../../../Actions";
import { withRefluxStore } from "../../../../Stores";
import { Group } from "../../../../Components/Layout";
import { ActionsGlobalMediaLibrary } from "../../../../Actions/ActionsGlobalMediaLibrary/ActionsGlobalMediaLibrary";
import { Store__System } from "@talentbait/shared-components";

const TopBar = ({ organization }) => {
  const { t } = useTranslation();
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState("");

  useEffect(() => {
    if (organization?.id) {
      Actions.getAllCompanies(organization.id);
      const getAllCompaniesCompletedRef = Actions.getAllCompanies.completed.listen((result) => {
        const { payload } = result;
        const companyOptions = payload.map((company) => ({
          label: company.name,
          value: company.id
        }));
        setCompanies(companyOptions);
        setCompanyId(companyOptions[0].value);
        ActionsGlobalMediaLibrary.setCompanyId(companyOptions[0].value);
        ActionsGlobalMediaLibrary.setCompanyName(companyOptions[0].label);
        getAllCompaniesCompletedRef();
      });
    }
  }, [organization?.id]);

  const handleCompanySelectChange = (selectedOption) => {
    if (selectedOption) {
      setCompanyId(selectedOption.value);
      ActionsGlobalMediaLibrary.setCompanyId(selectedOption.value);
      ActionsGlobalMediaLibrary.setCompanyName(selectedOption.label);
    } else {
      setCompanyId("");
    }
  };

  return (
    <TopBarContainer>
      <FilterNavWrapper>
        <Group gap={"15px"} direction="column" width="20%">
          <FilterTitle>{t("Company")}</FilterTitle>
          <Select
            id="company-select"
            isClearable={false}
            isSearchable={true}
            options={companies}
            value={companies.find((company) => company.value === companyId)}
            onChange={handleCompanySelectChange}
            styles={customStylesCompanies}
            placeholder={t("Select a company...")}
          />
        </Group>
      </FilterNavWrapper>
    </TopBarContainer>
  );
};

export default withRefluxStore(TopBar, [Store__System], ["organization"]);
